import { useSize } from '@hover/blueprint';
import { useScroll, useTransform } from 'framer-motion';
import type { RefObject } from 'react';

export const useStickHeaderShadowOpacity = (ref: RefObject<HTMLElement>) => {
  const size = useSize(ref);
  const { scrollY } = useScroll({ target: ref });

  const y = useTransform(scrollY, () => {
    if (ref.current) {
      const { top } = ref.current.getBoundingClientRect();
      return top;
    }
    return 0;
  });

  const opacity = useTransform(y, [size?.height ?? 0, 0], [0, 1]);

  return opacity;
};
